var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.027%",
    y1: "-5.708%",
    x2: "88.304%",
    y2: "101.98%",
    id: "hamburger_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16a1.5 1.5 0 0 1 0 3h-13a1.5 1.5 0 0 1 0-3h13Zm0-8a1.5 1.5 0 0 1 0 3h-23a1.5 1.5 0 0 1 0-3h23Zm-10-8a1.5 1.5 0 0 1 0 3h-13a1.5 1.5 0 0 1 0-3h13Z",
    fill: "url(#hamburger_svg__a)",
    fillRule: "evenodd"
  })));
};
export default SvgHamburger;